
export const featuredArray = [
    {
        img: 'https://s3-alpha-sig.figma.com/img/627d/2bb5/978e9e9e32b372e2ae4e558cebec038c?Expires=1723420800&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=pMm-5~5L4I51pWdsOGSe44a6WjMcwH89J2q~wFRFn9ZqfxcD4MUSZPYgUAL~9240X3By074~8F8jrOssgaQcCTzD4ibWjrICR2Tq42Zxe~cClm9g4B4EMDhS~TTWZHKIMXQlYwTRIDWDoyWa-hwbXfVlLfHN6H74r9-PfL1ySJGQe8IE36-diQkZQOAlDQxx-EKBKbf~aKDLawX88CsSdfVtFteBwg2r25m9z6Ktz1LMxoJRfZ0NvRzPI11shhBp~SQ33M7VMbLaGEPU0vyrXtdrW59tszYPEg-H2W1Q71SMe1C~IDut3~twIubWI1fpMJpVhkRRvSyd97rWUDT4DA__',
        title: 'Biology',
    },
    {
        img: 'https://s3-alpha-sig.figma.com/img/7ae7/a1c2/a783f8b60568e8b787fd351157e82fdf?Expires=1723420800&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=brQ4Vb--mtmtFGlE4K8q9lIXPZnGR56-pthvEGcQbPHRadqsEH4vh6PeUCSSyRvQn2cRVIyTI1il7XiJeUh7FURYMgDnSDnNgYcQv8lbc02GnSedujVZE3TCqjoj-4Z~8v6QlS5Muoaf5QwudTqB2C0C8swH94MM0YDU4NVJlomUyv3NTYgQdY7EXErU1KG3X4LGXRo6ZGbaMPiG3al2AOmIfLKYqBCUmE4ffjwAei5TkFCjMqWGqIYZwNa12EB-2qUVw1gV3HspjQ3AFmrNHp05XrahorYdNcSoprCstglFG9krgdfP43Lh2FiDPSl1EXWtu5y~e~WuYzTY823TIA__',
        title: 'Physics',
    },
    {
        img: 'https://s3-alpha-sig.figma.com/img/ed10/5bbe/84a739cc2e26943d997047d3b726ecfa?Expires=1723420800&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=mX-ZUMq86-xrOxoULY1ya9JExR59Rgacq648sm6YxpKvQ6j4OC3hi8wZ53mC45vWRtyeCZZ~Mny8HhY~s5L~kXeXmxbWt5YdGqchhKj2vkvFyrExlug3dyTAhIF7KqVdqCiAC9rd5xGwEsn0PrjaNMbV3GI9cOcGxxOSd63~v9V2EbOVxWsLc3kM4BPb1U9K36K~ccr976-BwKNejF-EtG8VxWQaFcLdJaczyu3njBxyTvUW-cfRHX6uIw9xdsoSKRQ3QFMWNUkwCKzSgG6LRZ7azoDppI50w4Pi0Enu5uMpHSmNRrnddSA6Gpp5cGnq9efswPe1kUjxsFga1g-49w__',
        title: 'Maths',
    },
    {
        img: 'https://s3-alpha-sig.figma.com/img/9b7b/3cfc/cdd53b219db65695c8afad4a9bcf913f?Expires=1723420800&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=lB~sclBlmrBKQ3VvVO0b45Z8dTVbRzypfAI0mJIv0Wtvt3zIRfTgTTielvx2i5u--s1LhbRzoOp2Kqp~RLfxlnxNO992~jPV7mA9pX8wAjk0FLKUoishpRg9h373isx7H69GTWBT2W1YuhVFdHRtONzl3QJ-WIzAk~dQu2GPonaYq5Uqz03nzQIehOainQ6iD61CJ0Bhs2pS4l4LHdBMXLuvYD2RdCuTxqi-GW0vJWUdvYzngJCFLEIwStDow4sEudL1muGulQti6An0dIp4-~1wwLomYHZ91qLmO-n5EYFfMT4G04JxHizd7uZA0s9ZUvcQNtCRZFLLk8~49USlKQ__',
        title: 'Chemistry',
    },
    {
        img: 'https://s3-alpha-sig.figma.com/img/3cf7/89c5/095b48b943d2dd26e8f236dc95544cec?Expires=1723420800&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=RJyDaRes5To9~WLkLeGF6fhSo5CsuJfoyDMP0ms1wcODYe4w9phM22k7EM~rUtr2S5LrL~Ufu4twKbWj2~ve91g7JHdaAnb5wFTQ6l9fkN43jVc2X55eHXXR8Olg1dGaFzPpwR3eMGEi1i9PG4zUGoJRP290R3ndvmHrV8X4OujRGBNp26hH3XCaG7bJmogc1zRv0dxwa5PtcWX5cKzehAe11KBAVWCdqjEnCQh3pgSV5L2ykJjPaEJOYLcAuIjDhCVAIazKRo0hc8c-8IVdENDVYZl3EXE-o~U-o1Vkhcf1VsUPxPNQJagnBrt6ptAXPD9Vp4ikEEkJzkFB07wWOg__',
        title: 'English',
    },
    {
        img: 'https://s3-alpha-sig.figma.com/img/4994/59d4/6999761854d1c647f9d53ec36e3cefe3?Expires=1723420800&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=ljpbXTCmBD7jCzKrG0T3dxygaBWtiK5fAG73Lc-DcM3Ff6MoAUa8OUdT52u7XoMtBs7apdAOb4JMwsDe0zdcAy30hUio80U3mpvVM51MwCEvt1I5e2xfqSirhoKfh4KW7RqNGVku8gbR0a6-yxCkjgA8H9CcYZRNiJ2EVDTZFi3~PB0E9k58HgzC4PCO5z0wQbJw8MGJPqYA1Gu6ZendAZPfgXZwhHCgaSLMG673aJlTQvsKG1uqTLG9ttVL4iGT5WE4gMdsWWfyPuy~Uq2eDrq-cf0KGVjHgQd6ped~vsUG7YCjpz66tcxp-XJJrT72EW6uH3O2cPjWTSv9rQEFgg__',
        title: 'Social Studies',
    }
];

export const recentResults = [
    {
        title: 'Science & Tecnology',
        percentage: 60,
    },
    {
        title: 'Geography & History',
        percentage: 85,
    },
    {
        title: 'English',
        percentage: 50,
    },
];

export const yourTopicsData = [
    {
        image: 'https://ambar-lab.com/wp-content/uploads/2021/06/Stem-Cells.jpg',
        topic: 'Cells',
        difficulty: 'Beginner',
        Lessons: 12,
        Practice: 15,
        Quizzes: 10,
        status: 'complete',
    },
    {
        image: 'https://assets.technologynetworks.com/production/dynamic/images/content/361448/artificial-cell-membrane-channels-can-be-opened-and-locked-with-a-key-361448-960x540.jpg?cb=11759517',
        topic: 'Cell Membrane',
        difficulty: 'Beginner',
        Lessons: 20,
        Practice: 12,
        Quizzes: 15,
        status: 'on progress',
    },
    {
        image: 'https://media.licdn.com/dms/image/D4D12AQHhTdXT_dJwow/article-cover_image-shrink_720_1280/0/1689000345510?e=2147483647&v=beta&t=TwLXylPsVYB2gwPPYRn9cPDtKRd7kQGPXcB6DOsmivs',
        topic: 'Evolution',
        difficulty: 'Beginner',
        Lessons: 20,
        Practice: 10,
        Quizzes: 8,
        status: 'on progress',
    },
];

export const premiumTopicsArray = [
    {
        image: 'https://media.sciencephoto.com/f0/29/25/80/f0292580-800px-wm.jpg',
        title: 'Cell Structure',
        Description: 'it is the structural and functional unit of a living organism',
        totalRating: (235),
        Rating: 5,
    },
    {
        image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR9v8WON5q034_GTqPDRcZpSh9h21TnAUAzUQ&s',
        title: 'Digestive System',
        Description: 'it consists of the gasterointestinal tract plus the accessory organs of digestion',
        totalRating: (235),
        Rating: 3.7,
    },
    {
        image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQXSZaF6zVPjkq6keiUZGc9uo7SAevGrYcJ7w&s',
        title: 'DNA and RNA',
        Description: 'Characteristics of viruses. DNA and RNA',
        totalRating: (200),
        Rating: 4,
    },
    {
        image: 'https://media.sciencephoto.com/f0/29/25/80/f0292580-800px-wm.jpg',
        title: 'Cell Structure',
        Description: 'it is the structural and functional unit of a living organism',
        totalRating: (235),
        Rating: 5,
    },
    {
        image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR9v8WON5q034_GTqPDRcZpSh9h21TnAUAzUQ&s',
        title: 'Digestive System',
        Description: 'it consists of the gasterointestinal tract plus the accessory organs of digestion',
        totalRating: (235),
        Rating: 3.7,
    },
    {
        image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQXSZaF6zVPjkq6keiUZGc9uo7SAevGrYcJ7w&s',
        title: 'DNA and RNA',
        Description: 'Characteristics of viruses. DNA and RNA',
        totalRating: (200),
        Rating: 4,
    },
];

export const topicsSliderData = [
    {
        title: 'Photography Course',
        Description: 'The course is for beginners. it will intrest for people who like photography. ',
        image: require('../../images/students/topics/slider1.jpg')
    },
    {
        title: 'Practice Mathematics',
        Description: 'The course is for beginners. it will intrest for people who like photography. ',
        image: require('../../images/students/topics/slider2.jpg')
    },
    {
        title: 'Solve Algebra',
        Description: 'The course is for beginners. it will intrest for people who like photography. ',
        image: require('../../images/students/topics/slider3.webp')
    },
];